import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const serviceStore = {
  namespaced: true,
  state: {
    serviceList: [],
  },
  getters,
  mutations,
  actions,
}

export default serviceStore



// WEBPACK FOOTER //
// ./src/store/serviceStore/index.js